import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "fw-semibold" }
const _hoisted_2 = { class: "d-flex justify-content-end" }

import moment from 'moment/moment';
import { debounce } from 'lodash';
import { useRouter } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import { ButtonsType, ButtonTypeColors } from '@/core/enums/buttons.enums';
import { DinhMucCoDinhService } from '@/core/services/DinhMucCoDinh.service';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { ICapSuaChuaResponseBase, IDanhMucToaXeResponseBase } from '@/core/interfaces/ApiResponses';
import { ICreateDinhMucCoDinh } from '@/core/interfaces/Models';
import { CapSuaChuaService } from '@/core/services/CapSuaChuaService.service';
import { getErrorMsg, swalNotification } from '@/core/helpers/utils';
import { useCreatingForm } from '@/core/hooks/use-creating-form';
import { useLoading } from '@/core/hooks/use-loading';
import DanhMucToaXeService from '@/core/services/DanhMucToaXe.service';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ResponsiveLayout from '@/layout/_shared/ResponsiveLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

setCurrentPageTitle('Định mức cố định');

const capSuaChuaItems = ref<ICapSuaChuaResponseBase[]>([]);

const { startLoading, endLoading, isLoading } = useLoading();

const { formRef } = useCreatingForm();

const { replace } = useRouter();

const fetchCapSuaChuaItems = async () => {
  try {
    await startLoading();

    const { data: { data: { data } } } = await CapSuaChuaService.list({});

    capSuaChuaItems.value = data;

    await endLoading();
  } catch (e) {
    await endLoading();

    await swalNotification(
        getErrorMsg(e, 'Có lỗi khi lấy thông tin cấp sửa chữa'),
        'error',
    );
  }
}

const defaultFormValue = {
  mo_ta: '',
  ngay_ban_hanh: new Date(),
  ngay_het_han: new Date(),
  id_cap_sc: 0,
  id_danh_muc_toa_xe: 0,
}

const form = ref(defaultFormValue);

const ngayBanHanhValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error('Bắt buộc phải nhập'));
  }

  if (value && moment(value).isAfter(form.value.ngay_het_han)) {
    callback(new Error('Ngày ban hành phải trước ngày hết hạn'));
  }

  callback();
}

const ngayHetHanValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error('Bắt buộc phải nhập'));
  }

  if (value && moment(value).isBefore(form.value.ngay_ban_hanh)) {
    callback(new Error('Ngày hết hạn phải sau ngaày ban hành.'));
  }

  callback();
}

const rules = ref({
  ngay_ban_hanh: [
    {
      validator: ngayBanHanhValidation,
      trigger: 'change',
    },
  ],
  ngay_het_han: [
    {
      validator: ngayHetHanValidation,
      trigger: 'change',
    }
  ],
  id_cap_sc: [
    {
      type: 'number',
      message: "Phải chọn cấp sửa chữa",
      trigger: 'change',
      min : 1,
    },
  ],
  id_danh_muc_toa_xe: [
    {
      type: 'number',
      message: "Phải chọn danh mục toa xe",
      trigger: 'change',
      min : 1,
    }
  ]
});

onMounted(async () => {
  await fetchCapSuaChuaItems();
});

const danhMucToaXeItems = ref<IDanhMucToaXeResponseBase[]>([]);

const search = debounce(async (query: string) => {
  isLoading.value = true;

  const { data: { data: { data } } } = await DanhMucToaXeService.list(1, 200, query);

  danhMucToaXeItems.value = data;

  isLoading.value = false;
}, 1000);

const clear = () => {
  form.value.mo_ta = '';

  form.value.id_cap_sc = 0;

  form.value.id_danh_muc_toa_xe = 0;

  form.value.ngay_het_han = new Date();

  form.value.ngay_het_han = new Date();
}

const payloadTransform = computed<ICreateDinhMucCoDinh>(() => ({
  mo_ta: form.value.mo_ta,
  id_danh_muc_toa_xe: form.value.id_danh_muc_toa_xe,
  id_cap_sc: form.value.id_cap_sc,
  ngay_het_han: form.value.ngay_het_han,
  ngay_ban_hanh: form.value.ngay_ban_hanh,
}))

const submit = async () => {
  if (!formRef.value) {
    return;
  }

  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      await startLoading();

      try {
        const { data: { data: { id } } } = await DinhMucCoDinhService.create(payloadTransform.value);

        await endLoading();

        await replace({
          name: 'chi-tiet-dinh-muc-co-dinh',
          params: {
            id,
          },
        });
      } catch (error) {
        await endLoading();

        await swalNotification(
          getErrorMsg(error, `Có lỗi xảy ra`),
          'error',
        )
      }
    } else return false;
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(" Tạo mới ")
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules.value,
        onSubmit: _withModifiers(() => {}, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(LabelCustom, {
                "is-text-muted": true,
                "is-required": false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Mô tả: ")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_el_input, {
                rows: 2,
                type: "textarea",
                modelValue: form.value.mo_ta,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.mo_ta) = $event)),
                name: "mo_ta",
                onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(LabelCustom, {
                "is-text-muted": true,
                "is-required": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ngày ban hành: ")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "ngay_ban_hanh",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: form.value.ngay_ban_hanh,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ngay_ban_hanh) = $event)),
                    class: "w-100",
                    placeholder: "Từ",
                    name: "ngay_ban_hanh",
                    format: "DD/MM/YYYY"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            "col-3": _withCtx(() => [
              _createVNode(LabelCustom, {
                "is-text-muted": true,
                "is-required": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ngày hết hạn: ")
                ]),
                _: 1
              })
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "ngay_het_han",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: form.value.ngay_het_han,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.ngay_het_han) = $event)),
                    class: "w-100",
                    placeholder: "Từ",
                    name: "ngay_het_han",
                    format: "DD/MM/YYYY"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(LabelCustom, {
                "is-text-muted": true,
                "is-required": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cấp S/C: ")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "mb-0 w-100",
                prop: "id_cap_sc"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.id_cap_sc,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.id_cap_sc) = $event)),
                    name: "id_cap_sc",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        disabled: true,
                        label: "Chưa chọn",
                        value: 0
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(capSuaChuaItems.value, (capSuaChua) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: capSuaChua.id,
                          label: capSuaChua.ten_cap_sc,
                          value: capSuaChua.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            "col-3": _withCtx(() => [
              _createVNode(LabelCustom, {
                "is-text-muted": true,
                "is-required": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" D/M toa xe: ")
                ]),
                _: 1
              })
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "mb-0 w-100",
                prop: "id_danh_muc_toa_xe"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.id_danh_muc_toa_xe,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.id_danh_muc_toa_xe) = $event)),
                    class: "w-100",
                    filterable: "",
                    name: "id_danh_muc_toa_xe",
                    placeholder: "Tìm kiếm ...",
                    remote: "",
                    "remote-method": _unref(search),
                    loading: _unref(isLoading),
                    "loading-text": "Đang tìm kiếm",
                    "no-match-text": "Không tìm thấy danh mục vật tư",
                    "no-data-text": "Không tìm thấy danh mục vật tư"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        disabled: true,
                        label: "Chưa chọn",
                        value: 0
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(danhMucToaXeItems.value, (dmToaXe) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: dmToaXe.id,
                          value: dmToaXe.id,
                          label: `${dmToaXe.ma_danh_muc} - ${dmToaXe.ten_danh_muc}`
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(dmToaXe.ma_danh_muc), 1),
                            _createTextVNode(" - " + _toDisplayString(dmToaXe.ten_danh_muc), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "remote-method", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(ResponsiveLayout, null, {
            "col-4": _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(ButtonCustom, {
                  "button-type": _unref(ButtonsType).SAVE,
                  onClick: submit
                }, null, 8, ["button-type"]),
                _createVNode(ButtonCustom, {
                  "button-type": _unref(ButtonsType).TRASH,
                  "color-type": _unref(ButtonTypeColors).DANGER,
                  onClick: clear
                }, null, 8, ["button-type", "color-type"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }))
}
}

})